import { localeDetails } from '~/components/CmsMain/localeGlobals';

export function isLocaleRegionIsUs() {
  return localeDetails.locale.region === 'US';
}

// ISO-2 region the current org's locale resolves to ('US', 'AU', 'GB', …).
// Null before locale bootstrap. Used as a fallback country for legacy rows
// persisted before policy_country was captured.
export function getLocaleRegion() {
  return localeDetails?.locale?.region ?? null;
}

export function isLocaleRegionIsUK() {
  return localeDetails.locale.region === 'GB' || localeDetails.locale.region === 'IE';
}

// Share logic with the backend intl_utils.py get_region_code() to keep consistent behavior
export const getRegionCode = () => {
  if (!localeDetails?.locale?.region) {
    return null;
  }

  switch (localeDetails?.locale.region) {
    case 'US':
      return 'US';
    case 'GB':
      return 'UK';
    case 'AU':
      return 'AU';
    default:
      return 'EU';
  }
};
